import { VCObserver } from './vc-observer';
var instance = null;
export var getVCObserver = function getVCObserver() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (instance === null) {
    instance = new VCObserver(opts);
  }
  return instance;
};